module.exports = __webpack_public_path__ + "media/img/apple-icon-114x114-995e31fb9269550e078bec9cc4d89569.png";